module.exports = __webpack_public_path__ + "static/contact-us-6b82a32566e062a7d258367213be5ec0.svg";